// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"edit-section-wrapper_wrapper__RDlmq","link":"edit-section-wrapper_link__67QFd"};